'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

function isBlank(object) {
  return isPlainObject(object) && isEmptyObject(object) || isArray(object) && object.length === 0 || typeof object === 'string' && object.trim() === '' || !object && object !== 0;
}
function isPresent(object) {
  return !isBlank(object);
}

function isPlainObject(obj) {
  var object = {};

  if (!obj || object.toString.call(obj) !== '[object Object]') {
    return false;
  }

  var prototype = Object.getPrototypeOf(obj);

  if (!prototype) {
    return true;
  }

  var constructor = object.hasOwnProperty.call(prototype, 'constructor') && prototype.constructor;
  return typeof constructor === 'function' && object.toString.call(constructor) === object.toString.call(Object);
}

function isEmptyObject(obj) {
  for (var _ in obj) {
    return false;
  }

  return true;
}

function isArray(obj) {
  return Array.isArray(obj);
}

exports.isBlank = isBlank;
exports.isPresent = isPresent;
